
import Typography from '@mui/material/Typography';


import { Link, Button } from 'gatsby-theme-material-ui';
import React from 'react';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { OnCloseDialogTitle } from '../../atoms/OnCloseDialogTitle';
import { ClosableDialog } from '../../molecules/ClosableDialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { useLanguageLink } from '../../hooks/useLanguageLink';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export const FeatureDialogIcon = ({ jargon, slug, children }) => {
  const myJargon = jargon?.[slug];
  const [open, setOpen] = React.useState(false);
  if (!myJargon) {
    return children;
  }
  const l = useLanguageLink();
  return (
    <>
      <ClosableDialog
        open={open}
        onClose={() => setOpen(false)}
        BackdropProps={{ style: { backgroundColor: 'white' } }}
        fullScreen
        TransitionComponent={Transition}
      >
        <OnCloseDialogTitle onClose={() => setOpen(false)}>{myJargon.pageTitle}</OnCloseDialogTitle>
        <DialogContent dividers={true} style={{
          height: '100%'
        }}>
          <Stack spacing={2}>
            <Typography>{myJargon.excerpt}</Typography>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                sx={{ ml: 'auto', mr: 'auto', width: { xs: '100%', md: 'auto' } }}
                to={l(`/learn-to-speak-car/${myJargon?.slug}`)} color={'secondary'} variant={'contained'}>Read
                More</Button>
            </Box>
          </Stack>
        </DialogContent>
      </ClosableDialog>
      <Link component={'button'} onClick={() => setOpen(true)} title={'What is this?'}>{children}</Link>
    </>
  );
};
export default FeatureDialogIcon;